import { FileExtension } from '@rp/shared/models';

const getExtensionFromName = (fileName: string): FileExtension | null => {
  const lastDotIdx = fileName.lastIndexOf('.');

  return lastDotIdx > 0 ? (fileName.slice(lastDotIdx + 1) as FileExtension) : null;
};

const removeExtensionFromName = (fileName: string): string => {
  const lastDotIdx = fileName.lastIndexOf('.');

  return lastDotIdx >= 0 ? fileName.substring(0, lastDotIdx) : fileName;
};

export const FileUtil = {
  getExtensionFromName,
  removeExtensionFromName,
};
